import { CircularProgress, Pagination, Stack } from '@mui/material';
import { SelectPageSize } from '../Select';
import { PaginationProps } from '@mui/x-data-grid/models/gridBaseSlots';

export function CustomPagination(props: PaginationProps) {
  const { page, rowsPerPage, count, rowsPerPageOptions, onPageChange, onRowsPerPageChange } = props;

  return (
    <Stack flexDirection="row" alignItems="center" gap={1}>
      <SelectPageSize
        currentPageSize={rowsPerPage}
        updatePageSize={
          onRowsPerPageChange ? (size: number) => onRowsPerPageChange(size) : () => null
        }
        pageSizeOptions={rowsPerPageOptions as number[]}
      />
      {count || count === 0 ? (
        <Pagination
          page={page + 1}
          count={count === 0 ? 1 : Math.ceil(count / rowsPerPage)}
          onChange={(_, newPage) => onPageChange(null, newPage - 1)}
        />
      ) : (
        <CircularProgress size="16px" />
      )}
    </Stack>
  );
}
